import * as _ from "lodash";
import http from "../constant/api";

export const groupService = {
  listGroup: async () => {
    const result = await http.get(`/api/group/list`);

    return result;
  },
  listGroupIdByUser: async () => {
    const result = await http.get(`/api/group/list/ids`);

    return result;
  },
  listGroupIdByStaff: async (staffId) => {
    const result = await http.get(`/api/group/list/ids/staff-id/${staffId}`);

    return result;
  },
};
